export default function Footer() {
    return (
        <footer
            className='flex justify-center items-center p-5 bg-primary-color'
            role='contentinfo'
        >
            <span>&#169; 2022 Justin Fowler</span>
        </footer>
    );
}
